export default class GenericHelper {

  static parseInformation(target, value, op, alt, prepend) {
    var v = null;
    if (Array.isArray(target)) {
      if (typeof op === "string") {
        for (var i = 0; i < target.length; i++)
          if (target[i][op].keyConstant == value || target[i][op].keyConstant == v) {
            v = target[i].value;
            break;
          }
      } else
        for (var i = 0; i < target.length; i++)
          if (target[i].keyConstant == value || target[i].keyConstant == v) {
            v = target[i].value;
            break;
          }
    }
    if (typeof v === "string") return (typeof prepend === "string" ? prepend : "") + v;
    return typeof alt !== "undefined" ? alt : "n/a";
  }


  static cancelBubble(ev) {
    if (ev.stopPropagation) ev.stopPropagation();
    else ev.cancelBubble = true;
    (ev.preventDefault) ? ev.preventDefault() : ev.returnValue = false;
    return false;
  }

  static copyProperties(from, to) {
    if (typeof from === "object" && from != null)
      if (typeof to === "object" && to != null) {
        for (var i in from)
          to[i] = from[i];
        return to;
      } else return from;
    else if (typeof to === "object" && to != null)
      return to;
    return null;
  }

}